<script setup>
  import { ref, computed } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import { useUserStore } from '@/stores/UserStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import SpotHeaderTitle from '@/components/SpotHeaderTitle.vue';
  import SpotHeaderPrimaryActionList from '@/components/SpotHeaderPrimaryActionList.vue';
  import ToolbarHeaderActionMenuPopup from '@/components/ToolbarHeaderActionMenuPopup.vue';
  import FavoriteSpotUserTip from "@/components/FavoriteSpotUserTip.vue";
  import ModalSaveSpotToProfile from '@/components/ModalSaveSpotToProfile.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();      

  const spotStore = useSpotStore();
  const userStore = useUserStore();

  const props = defineProps({
    showFavoritesUserTip: {
      type: Boolean,
      default: true
    }
  });    

  const isDesktop = useMediaQuery('(min-width: 840px)');
  const isSmallDevice = useMediaQuery('(max-width: 539px)');

  const headerButtons = ['favorite', 'map', 'complete-report'];  
  
  const showProfileModal = ref(false);
  const showManageAlertModal = ref(false);

  const showUserTip = computed(() => userStore.memberLevel > 0 && !isSmallDevice.value && !isDesktop.value && !$WEB_VIEW && props.showFavoritesUserTip);    

  function handleShowProfileModal() {
    showProfileModal.value = true;
  }
</script>
<template>
    <header class="jwx-toolbar-header">
      <div class="jwx-toolbar-header__main-content">
        <SpotHeaderTitle
          :spot="spotStore.spot"
          subhead="Widgets"
          :isNowcastingSpot="spotStore.isNowcast"
        />
  
        <SpotHeaderPrimaryActionList
          v-if="isDesktop"
          @update:showProfileModal="handleShowProfileModal"
          @showAlertManageModal="showManageAlertModal = true"
          :buttons="headerButtons"
        />

        <ToolbarHeaderActionMenuPopup v-else>
          <template #menu-content>
            <SpotHeaderPrimaryActionList
              @update:showProfileModal="handleShowProfileModal"
              :buttons="headerButtons"
            />
          </template>
          <template #misc>
            <FavoriteSpotUserTip
              v-if="showUserTip"
              :menu="true"
              alignment="right"
            />
          </template>
        </ToolbarHeaderActionMenuPopup>
      </div>

    </header>      

    <ModalSaveSpotToProfile
      v-model:showProfileModal="showProfileModal"
      v-if="showProfileModal"
      :profiles="userStore.userProfiles.profiles"
    />
</template>